import { useMutation } from '@tanstack/react-query'

import { TANSTACK_QUERY_KEY } from '@/constants/tanstack-query'
import { queryClient } from '@/context'
import { IHttpError } from '@/data/core'

import { ICreateClaimRequestPayload, ICreateClaimResponse, ReferralModel } from '../models'

export function useMutationClaimReferralReward() {
  return useMutation<ICreateClaimResponse, IHttpError, ICreateClaimRequestPayload>({
    mutationFn: async (payload) => {
      const res = await ReferralModel.claimReferralReward(payload)
      queryClient.invalidateQueries({ queryKey: [TANSTACK_QUERY_KEY.REFERRAL.ACCOUNT_COMMISSION_SUMMARY] })
      return res.data
    },
  })
}
